import { render, staticRenderFns } from "./EditProfileHeader.vue?vue&type=template&id=4e13116c&"
import script from "./EditProfileHeader.vue?vue&type=script&lang=js&"
export * from "./EditProfileHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports